import { render, staticRenderFns } from "./BulkSMS.vue?vue&type=template&id=d799f542"
import script from "./BulkSMS.vue?vue&type=script&lang=js"
export * from "./BulkSMS.vue?vue&type=script&lang=js"
import style0 from "./BulkSMS.vue?vue&type=style&index=0&id=d799f542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports